import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

const SqftSummaryEdges = (props) => {
  const {measureUnit, intl} = props;
  const {edges} = props;
  let messageTotal;

  return (
    edges.map((edge, index) => {
      switch(measureUnit) {
        case "Metric":
          messageTotal = "Total : "+  Math.ceil10(edge.length, -2) + " m";
          break;
        case "Imperial":
        default:
          if(edge.unit && edge.unit.toLowerCase() === "each") {
            messageTotal = edge.segments === 1
              ? intl.formatMessage({id: "sqft.navigation.summary.unit"}) +": "+ edge.realLength
              : intl.formatMessage({id: "sqft.navigation.summary.units"}) +": "+ edge.realLength
          } else {
            messageTotal = intl.formatMessage({id: "sqft.navigation.summary.totalLNFT"}) +": "+ Math.ceil10(edge.length, -2) +"\'";
          }
      }

      return (
        <div className="summary-list__item summary summary--green" key={index}>
          <div className="summary-title">{ edge.name ? edge.name.replace(/"/g, "&quot;") : 'Edge' } </div>
          <div className="summary-info">
            <div className="summary-info__left">
              <FormattedMessage id="sqft.navigation.summary.segments"/>: {edge.segments}
            </div>
            <div className="summary-info__right">{messageTotal}</div>
          </div>
        </div>
      )
    })
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit
});

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftSummaryEdges)
);
